var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMdcLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Navigation_Bar",
    "data-name": "Navigation Bar",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 183.451,
    height: 35,
    viewBox: "0 0 183.451 35",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_494",
    "data-name": "Rectangle 494",
    width: 183.451,
    height: 35,
    fill: "#1b305c"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1383",
    "data-name": "Group 1383",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1382",
    "data-name": "Group 1382",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6801",
    "data-name": "Path 6801",
    d: "M792.5,277.644h10.084a195.478,195.478,0,0,1,23.359-21.334,6.735,6.735,0,0,0,1.62-1.685,15.347,15.347,0,0,0,.8-2.035c.163-.5.732-2.167.8-2.642.2-1.456-1.567-1.354-2.516-.95a5.506,5.506,0,0,0-.59.3c-1.478.869-13.909,8.494-33.554,28.351",
    transform: "translate(-792.5 -242.963)",
    fill: "#1b305c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6802",
    "data-name": "Path 6802",
    d: "M915.814,231.673c.794-.05,2.1.422,1.726,1.85-.425,1.645-.97,3.265-1.467,4.888q-1.27,4.146-2.558,8.285-.662,2.13-1.323,4.259c-.915,2.927-2.431,7.265.527,9.566a5.264,5.264,0,0,0,2.065.877,9,9,0,0,0,6.532-1.164c.044-.023-2.558,0-1.7-3.241.423-1.625.973-3.224,1.487-4.823.593-1.848,1.2-3.692,1.806-5.536q1.385-4.226,2.779-8.449c.708-2.143,1.412-4.288,2.138-6.425a6.284,6.284,0,0,0,.531-3.59,2.128,2.128,0,0,0-2.092-1.557,6.066,6.066,0,0,0-2.725.763c-1.266.522-7.724,4.3-7.724,4.3",
    transform: "translate(-880.062 -226.61)",
    fill: "#1b305c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6803",
    "data-name": "Path 6803",
    d: "M948.258,277.911l-.327.325c-.375.371-.958.92-1.532.637-.781-.386-.3-1.422-.112-2.014.472-1.49,3.974-12.207,3.974-12.207l2.038-1.623,4.381-3.488,4.135-3.293c1.541-1.227,2.964-2.627,5.11-2.461a4.515,4.515,0,0,1,4.045,3.183,8.526,8.526,0,0,1-.113,4.179c-.553,2.514-1.526,4.985-2.325,7.427q-.614,1.876-1.235,3.748-.316.955-.631,1.91a3.594,3.594,0,0,0-.335,1.821.907.907,0,0,0,.6.753c.55.175.866-.175,1.268-.484.049.05-1.912,4.994-5.737,4.992a5.289,5.289,0,0,1-3.946-1.634c-1.48-1.671-.813-3.783-.315-5.687q.616-2.351,1.342-4.674c.069-.22.193-.565.059-.744-.506-.678-1.653.6-2.025.994-.892.945-1.807,1.879-2.734,2.8l-5.586,5.542",
    transform: "translate(-905.919 -246.685)",
    fill: "#1b305c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6804",
    "data-name": "Path 6804",
    d: "M1090.476,283.041h4.593l2.779,9.2h.038l2.741-9.2h4.611v13.986h-3.289l.114-10.471-.038-.038-2.986,10.508h-2.362l-2.987-10.508-.037.038.113,10.471h-3.289Z",
    transform: "translate(-1012.718 -268.315)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_493",
    "data-name": "Rectangle 493",
    width: 3.572,
    height: 13.986,
    transform: "translate(100.946 14.726)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6805",
    "data-name": "Path 6805",
    d: "M1225.7,283.042h4.63c1.569,0,4.367,0,6.181,2.608A7.148,7.148,0,0,1,1237.8,290c0,3.818-1.89,7.031-7.2,7.031h-4.9Zm3.572,10.848h1.531c2.665,0,3.421-1.852,3.421-3.837a4.93,4.93,0,0,0-.68-2.589,2.941,2.941,0,0,0-2.722-1.285h-1.55Z",
    transform: "translate(-1112.658 -268.316)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6806",
    "data-name": "Path 6806",
    d: "M1297.9,283.041h4.423c2.457,0,3.4.3,4.309,1a4.845,4.845,0,0,1,1.72,3.818,4.244,4.244,0,0,1-3.478,4.4l3.8,4.763h-4.083l-3.232-4.517h-.037v4.517H1297.9Zm3.421,7.031h1.266c2.1,0,2.344-1.323,2.344-2,0-1.266-.926-1.89-2.306-1.89h-1.3Z",
    transform: "translate(-1166.016 -268.315)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6807",
    "data-name": "Path 6807",
    d: "M1368.727,282.026a7.259,7.259,0,1,1-7.371,7.428,7.9,7.9,0,0,1,.548-2.986,7.268,7.268,0,0,1,6.823-4.442m.057,11.378a4.131,4.131,0,1,0-3.856-4.158,3.922,3.922,0,0,0,3.856,4.158",
    transform: "translate(-1212.91 -267.565)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6808",
    "data-name": "Path 6808",
    d: "M1454.6,291.041a7.168,7.168,0,0,1-7.069,5.5,7.259,7.259,0,1,1-.038-14.516,7.152,7.152,0,0,1,7.106,5.576h-3.742a3.625,3.625,0,0,0-3.384-2.438,3.869,3.869,0,0,0-3.743,4.083,3.922,3.922,0,0,0,3.762,4.158,3.73,3.73,0,0,0,3.364-2.362Z",
    transform: "translate(-1271.153 -267.564)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMdcLogo);
export default __webpack_public_path__ + "static/media/mdc-logo.e49aabd49d92957e6353f0d8d8007019.svg";
export { ForwardRef as ReactComponent };